exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.show-button[data-v-fd67a248] {\n        position: absolute;\n        top: 10px;\n        right: 10px;\n}\n.chat-container[data-v-fd67a248] {\n        position: absolute;\n        top: 3px;\n        background: white;\n        height: calc(100%-80px);\n}\n.call-status[data-v-fd67a248] {\n        position: absolute;\n        top: 50px;\n        right: 10px;\n        z-index: 9999;\n        color: aliceblue;\n}\n", ""]);

// exports
